import makeStyles from 'utils/makeStylesCompat'

const useStyles = makeStyles(theme => ({
  leftColumn: {
    [theme?.breakpoints?.down('lg')]: {
      display: 'none',
    },
    backgroundColor: '#3D5567',
    height: '100%',
    overflow: 'hidden',
  },
  forgotPasswordBtn: {
    fontSize: '16px',
    paddingRight: '5px',
    color: '#3D5567',
    '&:hover': { textDecoration: 'underline', cursor: 'pointer' },
  },
  backToLogin: {
    width: 'fit-content',
  },
  verifyEmailSubtexts: {
    fontSize: '16px',
  },
  verifyEmailBtns: {
    color: '#3D5567 !important',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '16px',
  },
  verifyEmailBtn: {
    color: '#3D5567 !important',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '16px',
    background: 'none',
    border: 'none',
    padding: 0,
  },
  subtitle1: {
    fontSize: '24px',
    fontWeight: '600',
  },
  myProfileInnerBox: {
    border: '1px solid ',
    borderColor: `${theme?.palette?.secondary?.main} !important`,
    borderRadius: '5px',
  },
  disableButtonOnEditImage: {
    cursor: 'default',
  },
  enabledButtonsOnEditImage: {
    cursor: 'pointer',
  },
  bottomDiv: {
    position: 'absolute',
    width: '430px',
    bottom: 20,
  },

  anchorColor: {
    color: 'var(--dark-info-dark, #0288D1)',
    textDecorationColor: 'var(--dark-info-dark, #0288D1)',
  },
  rightColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },

  leftColumnTypography: {
    fontFamily: 'Inter',
    textAlign: 'left',
    color: '#FFFFFF',
    '@media only screen and (max-width: 900px) ': {
      fontSize: '30px',
      fontWeight: 400,
      lineHeight: '35px',
      letterSpacing: '0px',
    },
    '@media only screen and (min-width: 901px) and (max-width: 1300px)': {
      fontSize: '32px',
      fontWeight: 400,
      lineHeight: '39px',
      letterSpacing: '0px',
    },
    '@media only screen and (min-width: 1301px) and (max-width: 1400px)': {
      fontSize: '34px',
      fontWeight: 400,
      lineHeight: '45px',
      letterSpacing: '0px',
    },
    '@media only screen and (min-width: 1401px) and (max-width: 1700px) ': {
      fontSize: '37px',
      fontWeight: 400,
      lineHeight: '50px',
      letterSpacing: '0px',
    },

    '@media only screen and (min-width: 1701px) and (max-width: 1900px) ': {
      fontSize: '40px',
      fontWeight: 400,
      lineHeight: '55px',
      letterSpacing: '0px',
    },
    '@media only screen and (min-width: 1901px) and (max-width: 2200px) ': {
      fontSize: '48px',
      fontWeight: 400,
      lineHeight: '60px',
      letterSpacing: '0px',
    },
    '@media only screen and (min-width: 2201px) ': {
      fontSize: '60px',
      fontWeight: 500,
      lineHeight: '68px',
      letterSpacing: '0px',
    },
  },
  leftColumnTypographySmall: {
    fontFamily: 'Inter',

    textAlign: 'left',
    color: '#FFFFFF',
    '@media only screen and (max-width: 900px) ': {
      fontSize: '10px',
      fontWeight: 400,
      lineHeight: '40px',
      letterSpacing: '0.15px',
      color: 'brown',
    },

    '@media only screen and (min-width: 901px) and (max-width: 1300px)': {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '40px',
      letterSpacing: '0.15px',
    },
    '@media only screen and (min-width: 1301px) and (max-width: 1400px)': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '40px',
      letterSpacing: '0.15000000596046448px',
    },

    '@media only screen and (min-width: 1401px) and (max-width: 1700px) ': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '45px',
      letterSpacing: '0.15000000596046448px',
    },

    '@media only screen and (min-width: 1701px) and (max-width: 1900px) ': {
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '46px',
      letterSpacing: '0.15000000596046448px',
    },
    '@media only screen and (min-width: 1901px) and (max-width: 2200px) ': {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: '50px',
      letterSpacing: '0.15000000596046448px',
    },
    '@media only screen and (min-width: 2201px) ': {
      fontSize: '22px',
      fontWeight: 500,
      lineHeight: '56px',
      letterSpacing: '0.15000000596046448px',
    },
  },
  imageContainer: {
    height: '58%',
  },
  fullHeightContainer: {
    height: '100%',
  },
  quoteGridContainer: {
    height: '42%',
  },
  quoteGrid: {
    height: '100%',
  },
  loginErrorContainer: {
    maxWidth: '400px',
    backgroundColor: '#FFFBFA',
    border: '1px solid #FDA29B',
    borderRadius: '12px',
    padding: '16px',
  },
  loginErrorIcon: {
    color: '#D92D20',
  },
  loginErrorHeading: {
    styleName: 'Text sm/Semibold',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    textAlign: 'left',
    color: '#B42318',
  },
  loginErrorText: {
    styleName: 'Text sm/Regular',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'left',
    color: '#B42318',
  },
}))

export default useStyles
